import {PlugTypeDto} from './plugType';

export class PlugTypeChoice {
    plugType: PlugTypeDto;
    hasPlugCable?: boolean;
}
